/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxSpecialDto } from '../../models/backend-tax-special-dto';
import { BackendTaxSpecialRequestDto } from '../../models/backend-tax-special-request-dto';

export interface ProjectTaxesTaxSpecialCreate$FormData$Params {
  body: BackendTaxSpecialRequestDto;
}

export function projectTaxesTaxSpecialCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxSpecialCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxSpecialCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxSpecialDto>;
    }),
  );
}

projectTaxesTaxSpecialCreate$FormData.PATH = '/api/project_taxes/tax_special/';
